import {config} from '@modules/config';

const commonAssetsHost = (): string => {
	const raw = config.get('host_commons_assets_ssl') || '';
	return raw.replace(/\/+$/, '');
};

const FONTS_BASE_PATH = '/fonts/deezer-product';

const buildFontUrl = (filename: string): string => {
	const host = commonAssetsHost();
	return host
		? `${host}${FONTS_BASE_PATH}/${filename}`
		: `${FONTS_BASE_PATH}/${filename}`;
};

export type FontFace = {
	family: string;
	weight: number;
	style: 'normal' | 'italic';
	woff2: string;
	woff?: string;
};

const DEEZER_PRODUCT_FONT_FACES: FontFace[] = [
	{
		family: 'Deezer Product',
		weight: 300,
		style: 'normal',
		woff2: 'DeezerProduct-Light.efd35bdb0915246feab41d1358b8cd5085fd20cd.woff2',
		woff: 'DeezerProduct-Light.cfee2dd7c4becdda1c9e8e9d9f4b6ba61f361bc3.woff',
	},
	{
		family: 'Deezer Product',
		weight: 400,
		style: 'normal',
		woff2:
			'DeezerProduct-Regular.70f89899e36fd31e61516d3d8735072f84e1834c.woff2',
		woff: 'DeezerProduct-Regular.fdde3d408773a19ee0b563751b99c4480516924d.woff',
	},
	{
		family: 'Deezer Product',
		weight: 500,
		style: 'normal',
		woff2:
			'DeezerProduct-Medium.daf0b392651bce99e22271f127d6798f00f7a1f7.woff2',
		woff: 'DeezerProduct-Medium.58cb919ec641feddea21f6a7afd51060691af3ce.woff',
	},
	{
		family: 'Deezer Product',
		weight: 700,
		style: 'normal',
		woff2: 'DeezerProduct-Bold.12a16421bc0c1a0e11b324a8ba1f3035aae0ada2.woff2',
		woff: 'DeezerProduct-Bold.14ce4332645cb3ca0f164d257e880853ed262798.woff',
	},
	{
		family: 'Deezer Product',
		weight: 800,
		style: 'normal',
		woff2:
			'DeezerProduct-Extrabold.ff5d8428e4fe802f91d53a06857feb145b0a435d.woff2',
		woff: 'DeezerProduct-Extrabold.a1c06d3aa3a0d709767a0e592c1bac25af1f6944.woff',
	},
];

export const PRELOAD_FONT = DEEZER_PRODUCT_FONT_FACES.find(
	(f) => f.weight === 700,
) as FontFace;

export const getFontUrl = (file: string): string => buildFontUrl(file);

export const buildFontFaceCss = (
	faces: FontFace[] = DEEZER_PRODUCT_FONT_FACES,
): string =>
	faces
		.map((face) => {
			const sources = [
				`url('${buildFontUrl(face.woff2)}') format('woff2')`,
				face.woff ? `url('${buildFontUrl(face.woff)}') format('woff')` : null,
			]
				.filter(Boolean)
				.join(', ');
			return `@font-face{font-family:'${face.family}';src:${sources};font-weight:${face.weight};font-style:${face.style};font-display:swap;}`;
		})
		.join('');
